import ProductPage from './themes/BGH/ProductPage';
export default ProductPage;
